import { ChargeComponent } from '@/dto/subscription/SublimeChargeDTO';

/**
 * Centralized reference for Subscription Plan component capabilities.
 * Currently, only PAYSTUB supports defaultIncludedUnits.
 * Extend this set in the future if other components start supporting it.
 */
const DEFAULT_INCLUDED_UNITS_SUPPORTED = new Set<ChargeComponent>([
  ChargeComponent.PAYSTUB,
]);

export function supportsDefaultIncludedUnits(component?: ChargeComponent | null): boolean {
  if (!component) return false;
  return DEFAULT_INCLUDED_UNITS_SUPPORTED.has(component as ChargeComponent);
}

export default {
  supportsDefaultIncludedUnits,
};
